import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Municipality } from './Municipality';
import { MunicipalityService } from './municipality.service';

@Injectable()
export class VerificationService {
  private municipality: Municipality;

  constructor(
    private _httpClient: HttpClient,
    private _municipalityService: MunicipalityService
  ) {
    this._municipalityService.currentMunicipality.subscribe(
      (data) => (this.municipality = data)
    );
  }

  // personal id verification
  checkUserAgreement() {
    return this._httpClient.get('/api/um/v2/user/agreement');
  }

  get getIdProtocolUrl(): string {
    const sessionId = localStorage.getItem('access_token');
    const isNewSession = 1; // true
    const userId = JSON.parse(localStorage.getItem('sessionData')).id;
    const clientId = this.municipality.clientId; // 41

    // PROD CONFIG
    // const userAgreementFileId: string = '5b60c18778a4982f77a9dcf3';
    // const umIdCardApplicationId: string = 'UM_PROD';

    // DEV CONFIG
    const userAgreementFileId = '5b60c18778a4982f77a9dcf3';
    // const umIdCardApplicationId: string = 'UM_PROD_TSOTNE';
    const umIdCardApplicationId = 'UM_PROD';

    return `geoeid-unitool://api.municipal.gov.ge/signature/idcard/meta?fileId=${userAgreementFileId}&clientId=${clientId}&id=${userId}&userId=${userId}&applicationId=${umIdCardApplicationId}&sessionId=${sessionId}&isNewSession=${isNewSession}`;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/verification.service.ts